import { takeLatest } from 'redux-saga/effects';
import fetchExemptedPolicyBundlesWorker from './exemptedPolicyBundlesWorkerSaga.js';
import { DOWNLOAD_EXEMPTED_BUNDLE_REQUEST, FETCH_EXEMPTED_POLICY_BUNDLES } from '../../redux/modules/exemptedPolicyBundles/exemptedPolicyBundles-actions';
import { commonGetWorkerSaga } from '../commonSaga/commonWorkerSaga';

function* fetchExemptedPolicyBundlesWatcher() {
    yield takeLatest(FETCH_EXEMPTED_POLICY_BUNDLES, fetchExemptedPolicyBundlesWorker);
}

export function* downloadExemptedZipBundleWatcher() {
    yield takeLatest(DOWNLOAD_EXEMPTED_BUNDLE_REQUEST, commonGetWorkerSaga);
}

export default fetchExemptedPolicyBundlesWatcher;
